import React, { useState, useEffect } from "react";
import "./IndependenceDayBanner.css";
import BannerImage from "../../assets/images/banner-3.png";

const IndependenceDayBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show banner after a short delay when component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="independence-banner-overlay">
      <div className="independence-banner" style={{ padding: "0px" }}>
        <button
          className="close-button"
          style={{ border: "none" }}
          onClick={handleClose}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="banner-content">
          <img
            src={BannerImage}
            height="100%"
            width="100%"
            alt="Independence Day Banner"
          />
        </div>
      </div>
    </div>
  );
};

export default IndependenceDayBanner;
